import { useEffect, useRef, useState } from 'react'
import cx from 'classnames'

type Props = {
  name: string | undefined
  hasError: boolean
  isReplacer: boolean
  hasParentNode?: boolean
  isActive?: boolean
  isEditable?: boolean
  isEditing?: boolean
  onNameChange?: (newName: string) => void
  onEditClick?: () => void
}

const TopicCardName = ({
  name,
  hasError,
  isReplacer,
  hasParentNode,
  isActive,
  isEditable = false,
  isEditing = false,
  onNameChange,
  onEditClick,
}: Props) => {
  const [editValue, setEditValue] = useState(name || '')
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus()
      inputRef.current.select()
    }
  }, [isEditing])

  useEffect(() => {
    setEditValue(name || '')
  }, [name])

  const handleBlur = () => {
    if (onNameChange) {
      onNameChange(editValue)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleBlur()
    } else if (e.key === 'Escape') {
      e.preventDefault()
      setEditValue(name || '')
    }
  }

  const displayName = isReplacer ? (name || '').replace(';', ', ') : name || ''

  if (isEditing) {
    return (
      <input
        ref={inputRef}
        type="text"
        value={editValue}
        onChange={(e) => setEditValue(e.target.value)}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        placeholder="Enter focus theme"
        className={cx(
          'text-base font-normal w-full bg-transparent border-none outline-none',
          {
            'text-red-600': hasError,
            'text-gold-700': !hasError && !hasParentNode && !isActive,
            'text-base-700': !hasError && hasParentNode && !isActive,
            'text-base-700 font-normal': !hasError && isActive,
          }
        )}
        style={{ minWidth: '60px' }}
      />
    )
  }

  return name ? (
    <span
      className={cx(
        'text-base font-normal overflow-ellipsis overflow-hidden whitespace-nowrap',
        {
          'text-red-600': hasError,
          'text-gold-700 group-hover:text-base-700':
            !hasError && !hasParentNode && !isActive,
          'text-base-700': !hasError && hasParentNode && !isActive,
          'text-base-700 font-normal': !hasError && isActive,
        }
      )}
    >
      {displayName}
    </span>
  ) : isEditable ? (
    <span
      className={cx('text-base font-normal text-base-400 italic', {
        'text-red-400': hasError,
      })}
    >
      Edit to add topic name
    </span>
  ) : null
}

export default TopicCardName
